import styled, { css } from 'styled-components';
import Colours from '/shared/styled/Colours';
import { breakpointDown } from '/shared/styled/Breakpoints';

import ThickDownArrow from '/business/airbp/images/icons/ThickDownArrow.svg';

interface Props {
  $hasArrow?: boolean;
  $hasWhiteBackground?: boolean;
  $isErrored?: boolean;
  $small?: boolean;
  $hasDropdown?: boolean;
  $highlight?: boolean;
  $dropdownSingleNoBorder?: boolean;
  disabled?: boolean;
}

function hasError({ $isErrored }: Props) {
  if ($isErrored) {
    return css`
      &, &:focus, &:active {
        border-color: ${Colours.redLight5};
        z-index: 2;
      }
    `;
  }

  return css`
      & {
        border-color: ${Colours.greyLight2};
        z-index: 2;
      }
    `;
}

function hasDropdownStyle({ $hasDropdown }: Props) {
  if ($hasDropdown) {
    return css`
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
    `;
  }
}

function hasWhiteBackgroundStyle({ $hasWhiteBackground = false }: Props) {
  if ($hasWhiteBackground) {
    return css`
      background: ${Colours.white};
    `;
  }
}

function disabledStyle({ disabled = false }: Props) {
  if (disabled) {
    return css`
      border-color: ${Colours.greyLight6};
      background: ${Colours.whiteDark1};
      color: ${Colours.greyLight1};
      opacity: 0.8;
      cursor: not-allowed;

      &::-webkit-input-placeholder {
        color: ${Colours.greyLight1} !important;
      }

      &:-ms-input-placeholder {
        color: ${Colours.greyLight1} !important;
      }

      &:focus, &:active {
        border-color: ${Colours.greyLight6};
        outline: none;
        z-index: 2;
      }
    `;
  }
}

function hasArrowStyle({ $hasArrow = true, $hasWhiteBackground = false }: Props) {
  if ($hasArrow && $hasWhiteBackground) {
    return css`
      background: ${Colours.white} url('${ThickDownArrow}') right 1rem top 50% no-repeat;
    `;
  }
  if ($hasArrow) {
    return css`
      background: url('${ThickDownArrow}') right 1rem top 50% no-repeat;
    `;
  }
}

export default styled.select<Props>`
  appearance: none;
  ${hasWhiteBackgroundStyle}
  ${hasArrowStyle}
  color: ${Colours.black};
  padding: 0.666666rem 2.75rem 0.666666rem 1.3rem;
  border: 1px solid ${Colours.greyLight2};
  border-radius: 1.5rem;
  line-height: 1.2;
  width: 100%;
  min-width: 8rem;
  margin: 0;
  font-size: 0.93333rem;
  font-weight: 400;

  &:focus, &:active {
    border-color: ${Colours.green};
    outline: none;
    z-index: 2;
  }

  &::-ms-expand {
    display: none;
  }
  ${breakpointDown('tablet')} {
    font-size: 0.9333rem;
    padding-left: 1.2rem;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  ${hasError}
  ${disabledStyle}
  ${hasDropdownStyle}
`;
